import * as urlUtils from 'utils/Url';
import constants from 'Constants';
import { getAuth, patchAuth, postAuth, deleteAuth } from 'api/Utils';


export function getViewControlManageUsers(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/control/manage-users`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function getViewControlUserShforms(successCallback, errorCallback, userId, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/control/user-shforms/${userId}`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function postControlLoginasUser(successCallback, errorCallback, userId) {
  postAuth({
    "path": `control/users/${userId}/loginas`,
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function postControlActivateUsers(successCallback, errorCallback, userId) {
  postAuth({
    "path": `control/users/${userId}/activate`,
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function postControlDeactivateUsers(successCallback, errorCallback, userId) {
  postAuth({
    "path": `control/users/${userId}/deactivate`,
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function postControlResendUserVerification(successCallback, errorCallback, userId) {
  postAuth({
    "path": `control/users/${userId}/resend-verification`,
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}
